import { render, staticRenderFns } from "./appversion.vue?vue&type=template&id=32a8ca86&"
import script from "./appversion.vue?vue&type=script&lang=js&"
export * from "./appversion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports